// extracted by mini-css-extract-plugin
export default {"wrapper":"trust-pilot-module--wrapper--85dbc","compact":"trust-pilot-module--compact--bdaf6","withBorderBottom":"trust-pilot-module--with-border-bottom--37bc4"};